export default "__VITE_ASSET__Ce6$mwXK__"